import React from 'react'
import PropTypes from 'prop-types'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './section.module.scss'

const Section = ({
  title,
  Actions,
  onClickSeeMore,
  styleContent,
  contentWrap,
  lastItem,
  children
}) => {
  return (
    <Flex column margin="48px 0">
      <div className={styles.flex}>
        <Text
          size="lg"
          color="gray"
          variation="dark"
          extraBold
          margin="0 5px 0 0"
        >
          {title}
        </Text>

        {Actions && <Actions />}
      </div>
      <Flex
        wrap={contentWrap}
        alignItems="center"
        padding="0"
        style={styleContent}
      >
        {children}
      </Flex>
      {onClickSeeMore && !lastItem && (
        <Flex
          alignItems="center"
          justifyContent="center"
          margin="32px 0px 0px 0px"
        >
          <button
            type="button"
            onClick={() => onClickSeeMore()}
            className={styles.actionWhite}
          >
            <Text
              font="custom"
              color="gray"
              variation="dark"
              size="xs"
              fontWeight="600"
              lineHeight="20px"
            >
              ver mais
            </Text>
          </button>
        </Flex>
      )}
    </Flex>
  )
}

Section.defaultProps = {
  Actions: null,
  onClickSeeMore: null,
  styleContent: null,
  lastItem: false,
  contentWrap: null
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  lastItem: PropTypes.bool,
  Actions: PropTypes.func,
  onClickSeeMore: PropTypes.func,
  styleContent: PropTypes.shape({}),
  contentWrap: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ]).isRequired
}

export default Section
